import { connect } from 'react-redux';
import GrafikAnalisisDetail from '../../../views/Library/GrafikAnalisis/GrafikAnalisisDetail.library.view';
import { getStudent } from '../../../states/thunks/student.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}

export default connect(null, mapDispatchToProps)(GrafikAnalisisDetail);
